import React, { useState, useEffect } from "react";

const Gallery = () => {
  const [docs, setDocs] = useState([]);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    setDocs(JSON.parse(localStorage.getItem("documents")) || []);
  }, []);

  const deleteDoc = (i) => {
    const d = docs.filter((_, idx) => idx !== i);
    localStorage.setItem("documents", JSON.stringify(d));
    setDocs(d);
  };

  const clearAll = () => {
    localStorage.removeItem("documents");
    setDocs([]);
  };

  return (
    <div style={styles.fullScreen}>
      <div style={styles.container}>
        <h2 style={styles.heading}>🖼 Gallery</h2>

        <div style={styles.btnRow}>
          <button style={styles.clearBtn} onClick={clearAll}>
            Clear All
          </button>

          <button style={styles.backBtn} onClick={() => window.location.href = "/dashboard"}>
            Back to Dashboard
          </button>
        </div>

        <div style={styles.grid}>
          {docs.map((d, i) => (
            <div key={i} style={styles.card}>
              <img
                src={d.after}
                alt=""
                style={styles.thumb}
                onClick={() => setOpen(d)}
              />
              <button style={styles.deleteBtn} onClick={() => deleteDoc(i)}>
                Delete
              </button>
            </div>
          ))}
        </div>

        {open && (
          <div
            onClick={() => setOpen(null)}
            style={styles.modal}
          >
            <img src={open.before} style={styles.modalImg} alt="" />
            <img src={open.after} style={styles.modalImg} alt="" />
          </div>
        )}
      </div>
    </div>
  );
};

export default Gallery;

const styles = {
  fullScreen: {
    background: "linear-gradient(to right, #0f2027, #203a43, #2c5364)",
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  container: {
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    padding: "40px",
    borderRadius: "20px",
    width: "90%",
    maxWidth: "1000px",
    boxShadow: "0 0 20px rgba(255, 255, 255, 0.2)",
    textAlign: "center",
  },
  heading: {
    color: "#FFD700",
    fontSize: "36px",
  },
  btnRow: {
    display: "flex",
    justifyContent: "center",
    gap: 15,
    marginBottom: 20,
  },
  clearBtn: {
    padding: "12px 30px",
    borderRadius: 12,
    border: "none",
    background: "#00C9A7",
    color: "#fff",
    fontWeight: "bold",
    cursor: "pointer",
  },
  backBtn: {
    padding: "12px 30px",
    borderRadius: 12,
    border: "none",
    background: "#FF7A00",
    color: "#fff",
    fontWeight: "bold",
    cursor: "pointer",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
    gap: 15,
    marginTop: 20,
  },
  card: {
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    padding: 10,
    borderRadius: 12,
    textAlign: "center",
  },
  thumb: {
    width: "100%",
    borderRadius: 10,
    cursor: "pointer",
  },
  deleteBtn: {
    marginTop: 10,
    width: "100%",
    padding: "10px",
    borderRadius: 10,
    border: "none",
    background: "#FF7A00",
    color: "#fff",
    fontWeight: "bold",
    cursor: "pointer",
  },
  modal: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.9)",
    display: "flex",
    gap: 20,
    padding: 40,
    justifyContent: "center",
    alignItems: "center",
  },
  modalImg: {
    width: "45%",
    borderRadius: 12,
  },
};
